import { useEffect, useState } from 'react';
import { useFeedback } from './use-feedback';

// Carrega listas não paginadas (cadastros orçamentários) a cada searchTrigger, exibindo erro quando a consulta falha
export function useArrayList<TParams, TRow>(
    load: (parameters: TParams) => Promise<TRow[]>,
    parameters: TParams,
    searchTrigger: number,
    errorMessage: string,
) {
    const { showError } = useFeedback();
    const [rows, setRows] = useState<TRow[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        load(parameters)
            .then((result) => setRows(result || []))
            .catch((error: any) => showError(errorMessage, error))
            .finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTrigger]);

    return { rows, loading };
}
